import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'tooltip',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent {
  @ViewChild("customTooltip") customTooltip: ElementRef |null  = null;
  @Input() template: TemplateRef<any> | null = null;
  tooltip: string = '';
  left: number = 1000;
  top: number = 1000;
  width: number = 0;
  height: number = 0;
  minWidth: string = 'auto';
  maxWidth: string = 'none';
  visible: boolean = false;

  constructor() {}

  ngOnInit(): void {
  }

  ngAfterViewChecked() {
    const tooltipElem = this.customTooltip?.nativeElement;
    if (tooltipElem && (this.width === 0 || this.height === 0)) {
      this.width = tooltipElem.offsetWidth;
      this.height = tooltipElem.offsetHeight;
    }
  }
}
